__turbopack_context__.v({
  "container": "CenteredPageContent-module__riZ99G__container",
  "featured": "CenteredPageContent-module__riZ99G__featured",
});
